module.exports = __webpack_public_path__ + "img/grey_047.a8bd77fb.png";